/* eslint-disable @typescript-eslint/no-floating-promises */
import { Button, Card, Checkbox, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { userLogin } from "../redux/slices/user/authActions";
export const LoginPage = (): JSX.Element => {
  const { userInfo } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  // const { register, handleSubmit } = useForm()
  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log(3333)

  //   console.log(4444)
  //   dispatch(getUserInfo());

  // }, [])

  useEffect(() => {
    if (userInfo?.id != null) {
      navigate("/");
    }
  }, [navigate, userInfo]);

  const onFinish = (values: any): void => {
    console.log("Success:", values);
    dispatch(userLogin(values));
  };

  const onFinishFailed = (errorInfo: any): void => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Row justify="space-around" align="middle" style={{ height: "100vh" }}>
      <Card title="Вход в админ-панель">
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Логин"
            name="username"
            rules={[{ required: true, message: "Введите логин" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: "Введите пароль" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="remember"
            valuePropName="checked"
            wrapperCol={{ offset: 8, span: 16 }}
          >
            <Checkbox>Запомнить меня</Checkbox>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Войти
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Row>
  );
};
